import actions from './actionTypes';

export const accountHasValidOrigin = () => {
  return dispatch => dispatch({ type: actions.ACCOUNT_BUILDER_VALID_ORIGIN, valid: true });
};

export const clearAccountOrigin = () => {
  return dispatch => dispatch({ type: actions.CLEAR_ACCOUNT_BUILDER_ORIGIN, valid: false });
};